import { useMutation, useQueryClient } from "react-query";
import { editOfficeHierarchy } from "../../../../actions/OfficeHierarchy";
const useEditOfficeHierarchy = () => {
  return useMutation(editOfficeHierarchy);
};
export default useEditOfficeHierarchy;
